/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const BidPlacedBySchema = z.enum(["USER", "AUTO_BID"])
